module.exports = __webpack_public_path__ + "static/a-b18b902963321760431661e3f6d6c6b5.jpg";